export const RelativeAsOfDateOptions = {
  Today: 'Today',
  CurrentMonth: 'CurrentMonth',
  CurrentPeriod: 'CurrentPeriod',
  CurrentFiscalYear: 'CurrentFiscalYear',
  PriorMonth: 'PriorMonth',
  PriorPeriod: 'PriorPeriod',
  PriorFiscalYear: 'PriorFiscalYear'
} as const;

type Values<T> = T[keyof T];

export type RelativeAsOfDateOption = Values<typeof RelativeAsOfDateOptions>;
